import React from 'react';
import { motion } from 'framer-motion';
import { SiblingFigure } from './characters/SiblingFigure';
import { siblings } from '../data/siblings';
import type { SiblingRole } from '../types/snak';
interface SiblingGuessRowProps {
  guess: SiblingRole | null;
  onGuess: (role: SiblingRole) => void;
}
export function SiblingGuessRow({
  guess,
  onGuess
}: SiblingGuessRowProps) {
  const odd = siblings.length % 2 === 1;
  return <div className="grid grid-cols-2 gap-2.5" data-id="element-422" data-mp="6zvbv36la58o">
      {siblings.map((sibling, i) => {
      const isGuess = guess === sibling.id;
      const wide = odd && i === siblings.length - 1;
      return <motion.button key={sibling.id} type="button" onClick={() => onGuess(sibling.id)} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: guess && !isGuess ? 0.4 : 1,
        y: 0
      }} transition={{
        delay: guess ? 0 : 0.1 + i * 0.06,
        duration: 0.4,
        ease: 'easeOut'
      }} whileTap={{
        scale: 0.96
      }} className={['flex items-center gap-2 rounded-2xl px-3 py-2 text-left transition-colors', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary', wide ? 'col-span-2' : '', isGuess ? 'bg-white text-background' : 'bg-white/[0.08] text-white ring-1 ring-white/15 hover:bg-white/[0.14]'].join(' ')} aria-pressed={isGuess} data-id="element-423" data-mp="gqzrm5439u4k" data-mpi={i}>
            <SiblingFigure role={sibling.id} className="h-10 w-10 shrink-0" data-id="element-424" data-mp="3ext181w60ma6" />
            <span className="font-body text-[13px] leading-tight" data-id="element-425" data-mp="3a5hvujino8a8">{sibling.label}</span>
          </motion.button>;
    })}
    </div>;
}